const menuAboutHR = {
    "view": {
        "label": {
            "myProfile": "Moj profil",
            "twoFactorAuthentication": "Dvofaktorska autentifikacija",
            "mySubscription": "Moja pretplata",
            "announcements": "Obavijesti",
            "mySubUsers": "Moji podkorisnici",
            "myLabels": "Moje etikete",
            "escrowWallet": "Escrow novčanik",
            "copyright": "Povrede autorskih prava",
            "financialStatements": "Financijski izvještaji",
            "userStatements": "Izvještaji korisnika",
            "subuserStatements": "Izvještaji podkorisnika",
            "invoices": "Računi",
            "paymentMethods": "Metode plaćanja",
            "purchaseHistory": "Povijest kupnje",
            "accessKeys": "Pristupni ključevi",
            "logout": "Odjava"
        }
    }
};

export default menuAboutHR;